/**
 * Get the available camera angles for video content with translations
 * @param {object} intl - The intl instance used for translations
 * @returns {Readonly<{[key: string]: string}>} An object mapping track IDs to their translated names
 */
export const getCameraAngleFromTrack = (intl) =>
  Object.freeze({
    1: intl.formatMessage({
      defaultMessage: 'Broadcast',
      id: 'be55b',
    }),
    2: intl.formatMessage({
      defaultMessage: 'Wide Angle (Side)',
      id: '26074',
    }),
    3: intl.formatMessage({
      defaultMessage: 'Wide Angle (End)',
      id: '8b2f5',
    }),
    4: intl.formatMessage({
      defaultMessage: 'Drone',
      id: 'a1789',
    }),
    5: intl.formatMessage({
      defaultMessage: 'Wide Angle (Multiple)',
      id: 'cf7d8',
    }),
    11: intl.formatMessage({
      defaultMessage: 'Other',
      id: '6311a',
    }),
  });

export default getCameraAngleFromTrack;
